export enum PayerEnum {
  VENDOR = 'vendor',
  CUSTOMER = 'customer',
  RECIPIENT = 'recipient',
  SENDER = 'sender',
  CUSTOMER_UPPERCASE = 'CUSTOMER',
  SELLER_UPPERCASE = 'SELLER',
}
